import theme from "./theme";

export const tableStyles = {
  tableContainer: {
    backgroundColor: theme.table.background.primary,
    borderRadius: theme.borderRadius.md,
    overflowX: "auto",
  },
  tableHead: {
    backgroundColor: theme.table.background.header,
  },
  tableRow: {
    cursor: "auto",
    ":hover": {
      backgroundColor: theme.utils.getHoverColor(
        theme.table.background.secondary
      ),
    },
    backgroundColor: theme.table.background.secondary,
    borderBottom: `1px solid ${theme.table.border}`,
  },
  tableCell: {
    color: theme.table.text.primary,
    borderBottom: `1px solid ${theme.table.border}`,
    fontSize: "13px",
    padding: "10px",
  },
  tableHeaderCell: {
    color: theme.table.headerText.primary,
    fontWeight: theme.table.headerText.fontWeight,
    borderBottom: `1px solid ${theme.table.border}`,
    fontSize: "13px",
    padding: "10px",
    backgroundColor: theme.table.background.primary,
  },

  accuracyBarContainer: {
    width: "50px", // much narrower than 100%
    height: "6px", // half as tall
    backgroundColor: "#2f333b",
    borderRadius: "4px",
    overflow: "hidden",
    flexShrink: 0,
    ml: 1,
  },
  getAccuracyBar: (val) => ({
    width: `${val}%`,
    height: "100%",
    backgroundColor: theme.utils.getAccuracyColor(val),
    transition: "width 0.3s ease-in-out",
  }),

  statusButton: {
    backgroundColor: theme.table.statusButton.background,
    color: theme.table.statusButton.color,
    border: `1px solid ${theme.table.statusButton.border}`,
    padding: "4px 8px",
    borderRadius: "6px",
    fontSize: "12px",
    cursor: "pointer",
  },
};
